import React from 'react';
import { toEuro } from '../../../../../../utils/stringUtils';
import ComparisonMatrixOffer from './ComparisonMatrixOffer';
import { LouiseQuote } from '../../../../../../../../../types/Quotes';
import { useTranslation } from 'react-i18next';
import InsuranceCompanyLogo from '../../../../../../../../common/src/components/InsuranceCompanyLogo';
import { getGuaranteeNameForKey } from '../../../../../../services/productFactoryService';
import { useLouiseSelector } from '../../../../../../store/redux/store';
import ComparisonMatrixFlowerBox from './ComparisonMatrixFlowerBox';

interface Props {
  riskObject: string;
  quotes: LouiseQuote[];
  addToSelectedOffers: (arg0: string) => void;
  removeFromSelectedOffers: (arg0: string) => void;
}

const ComparisonMatrixHeader: React.FC<React.PropsWithChildren<Props>> = ({
  riskObject,
  quotes,
  addToSelectedOffers,
  removeFromSelectedOffers,
}) => {
  const { t } = useTranslation();
  const { selectedOffers } = useLouiseSelector((state) => state.offers);

  return (
    <>
      <ComparisonMatrixFlowerBox quotes={quotes} riskObject={riskObject} />
      {quotes.map(
        ({
          hash_id,
          info,
          details,
          matching_score,
          bestOffer,
          premium,
          guarantee_content,
        }) => (
          <ComparisonMatrixOffer
            key={hash_id}
            Icon={<InsuranceCompanyLogo insuranceCompany={info.company.key} />}
            insuranceCompany={info.company?.name || t('Insurer')}
            insuranceName={getGuaranteeNameForKey(
              info.insurance_name,
              guarantee_content,
            )}
            premium={toEuro(premium.total_premium)}
            interval={details.payment_interval}
            score={matching_score}
            bestOffer={bestOffer}
            isSelected={selectedOffers[riskObject]?.includes(hash_id)}
            addToSelectedOffers={() => addToSelectedOffers(hash_id)}
            removeFromSelectedOffers={() => removeFromSelectedOffers(hash_id)}
          />
        ),
      )}
      <div />
    </>
  );
};

export default ComparisonMatrixHeader;
